import createReduxForm from './createReduxForm';
import plain from './structure/plain';

export default createReduxForm(plain);


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/reduxForm.js
// module id = 2068
// module chunks = 0